import type { Microsoft365BrowseAt, Microsoft365Source } from '@dbrain/shared';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { SourceTile } from './icons.js';

/**
 * The picker's left side (MsBelgeSec): the sources the firm has on, the current one marked; under SharePoint the
 * sites the person follows ("SİTELER", the current one bold) and "Tüm siteler…" (a search by site name, taslaksız).
 */
export function PickerNav({
  sources,
  source,
  sites,
  currentSite,
  onSource,
  onSite,
  onAllSites,
}: {
  sources: readonly Microsoft365Source[];
  source: Microsoft365Source;
  /** the followed sites, once the SharePoint start said them */
  sites: { name: string; at: Microsoft365BrowseAt }[] | null;
  /** the site the current view is in */
  currentSite: string | null;
  onSource: (source: Microsoft365Source) => void;
  onSite: (at: Microsoft365BrowseAt) => void;
  onAllSites: () => void;
}) {
  const { t } = useTranslation();
  const sitesId = useId();
  return (
    <nav className="m365-picker__nav" aria-label={t('microsoft365.files.picker.nav')} data-testid="m365-picker-nav">
      <ul className="m365-nav">
        {sources.map((item) => (
          <li key={item}>
            <button
              type="button"
              className={item === source ? 'm365-nav__item m365-nav__item--active' : 'm365-nav__item'}
              aria-current={item === source ? 'true' : undefined}
              onClick={() => onSource(item)}
              data-picker-start={item === source ? '' : undefined}
              data-testid={`m365-picker-source-${item}`}
            >
              <SourceTile source={item} size="md" />
              {t(`microsoft365.files.sources.${item}`)}
            </button>
          </li>
        ))}
      </ul>
      {source === 'sharepoint' ? (
        <div className="m365-nav__sites">
          <p className="m365-nav__heading" id={sitesId}>
            {t('microsoft365.files.picker.sites')}
          </p>
          <ul aria-labelledby={sitesId}>
            {(sites ?? []).map((site) => {
              const current = site.at.kind === 'site' && site.at.siteId === currentSite;
              return (
                <li key={site.at.kind === 'site' ? site.at.siteId : site.name}>
                  <button
                    type="button"
                    className={current ? 'm365-nav__site m365-nav__site--current' : 'm365-nav__site'}
                    aria-current={current ? 'true' : undefined}
                    onClick={() => onSite(site.at)}
                    data-testid="m365-picker-site"
                  >
                    {site.name}
                  </button>
                </li>
              );
            })}
            <li>
              <button type="button" className="m365-nav__site m365-nav__site--all" onClick={onAllSites} data-testid="m365-picker-all-sites">
                {t('microsoft365.files.picker.allSites')}
              </button>
            </li>
          </ul>
        </div>
      ) : null}
    </nav>
  );
}
